<template>
  <div class="top-navigation shadow py-4">
    <div class="flex items-center" style="align-items: center">
      <div class="sidebar-toggle" @click="toggleSideNav">
        <navbar-toggle />
      </div>
      <div class="cursor-pointer mt-1" @click="moveToDashboard">
        <span v-if="$_3pl" class="text-lg font-[500] ml-3 inline-flex items-center gap-3"> <img alt="company-logo" :src="appLogo.img" class="w-8 h-8 rounded-full object-cover shadow-sm"/>{{ appLogo.name }}</span>
        <muleex-logo v-else/>
      </div>
    </div>
    <div class="items-center flex-1 flex justify-end">
      <div class="flex items-center">
        <div class="px-2 hidden md:flex" v-if="userAccountType == 'enterprise_partner'">
          <div class="mr-3">
            <el-dropdown placement="bottom-end" trigger="click">
              <div class="border border-neutral-300 rounded-lg px-3 py-2 bg-white font-semibold flex justify-between"
                :style="{ width: '275px', top: '200px', height: '40px' }">
                <p class="overflow-hidden">
                  {{
                    currentLocation == undefined
                      ? "No Location for user"
                      : locations.find((x) => x.locationId == currentLocation) !=
                        undefined
                        ? locations.find((x) => x.locationId == currentLocation).location
                  .locationName
                  : ""
                  }}
                </p>
                <i class="el-icon-arrow-down el-icon--right mt-1"></i>
              </div>
              <el-dropdown-menu :style="{ 'max-height': '80vh', 'overflow-y': 'auto' }">
                <el-dropdown-item v-for="locationT in locations" :key="locationT.location.id">
                  <div :style="{ width: '245px' }" class="flex gap-12 justify-between border-b border-neutral-300">
                    <p>{{ locationT.location.locationName }}</p>
                    <el-switch class="mt-2" v-model="currentLocation" :active-value="locationT.location.id"
                      active-color="#FFA600" inactive-color="#EEEEEE">
                    </el-switch>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>


        <span class="px-2 mt-2">
          <Hints />
        </span>
        <span class="px-2 mt-2">
          <notification-icon />
        </span>
        <span class="px-2 mt-2 cursor-pointer" @click="openSettings">
          <settings-icon />
        </span>
      </div>
      <div ref="actions" class="flex items-center user-profile cursor-pointer" @click="showAction = !showAction">
        <user-profile-image class="mr-1" />
        <span class="px-2 hidden md:flex">Hi, {{ userName }}</span>
        <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1.38672L5 5.38672L9 1.38672" stroke="#10233E" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </div>
      <div class="actions" v-if="showAction">
        <div class="flex flex-col gap-4 bg-transparent">
          <div class="w-100 flex items-center gap-4 cursor-pointer">
            <user-profile-image />

            {{ userName }}
          </div>
          <hr />
          <router-link class="font-normal w-100 py-0" :to="_isIndividual ? null : { name: 'AccountSettings' }">
            <div class="w-100 cursor-pointer text-left" @click="showAction = false">
              Profile Settings
            </div>
          </router-link>
          <div class="w-100 text-gray-300 cursor-pointer py-1" @click="showAction = false">
            Domains
          </div>
          <div class="w-100 text-gray-300 cursor-pointer py-1" @click="showAction = false">
            Support
          </div>
          <div class="w-100 text-gray-300 cursor-pointer py-1" @click="showAction = false">
            Feedback
          </div>
          <div class="w-100 text-gray-300 cursor-pointer py-1" @click="showAction = false">
            Terms of service
          </div>
          <hr />
          <div class="text-red w-100 cursor-pointer" @click="logout">Sign Out</div>
        </div>
      </div>
    </div>
    <dashboard-navigation :show-modal="showDashboardModal" @close-modal="showDashboardModal = false" />
  </div>
</template>

<script>
import MuleexLogo from "./MuleexLogo";
import NavbarToggle from "./NavbarToggle";
import NotificationIcon from "./NotificationIcon";
import SettingsIcon from "./SettingsIcon";
import UserProfileImage from "./UserProfileImage";
import DashboardNavigation from "@/components/3pl/Dashboard/Navigation";
import { userType } from "./constant/userType";
import Hints from "./HintsComponent.vue";

export default {
  components: {
    MuleexLogo,
    NavbarToggle,
    NotificationIcon,
    SettingsIcon,
    UserProfileImage,
    DashboardNavigation,
    Hints
  },
  data() {
    return {
      showDashboardModal: false,
      showAction: false,
      locations: [],
      currentLocation: undefined,
    };
  },
  activated() {
    if (localStorage.getItem("currentLocation")) {
      this.currentLocation = localStorage.getItem("currentLocation");
      this.$store.dispatch("setCurrentLocationId", this.currentLocation);
    }
  },
  mounted() {
    this.getLocationsManaged();
    this.outSideClick(this.$refs.actions, () => {
      this.showAction = false;
    });

    if (localStorage.getItem("currentLocation")) {
      this.currentLocation = localStorage.getItem("currentLocation");
      this.$store.dispatch("setCurrentLocationId", this.currentLocation);
    } else {
      this.getLocationsManaged();
    }
  },
  computed: {
    appLogo() {
      let company = JSON.parse(localStorage.getItem("organizationDetails"));
      return { name: `${company?.companyname}` , img: company?.orgimage }
    },
    isConsumer() {
      return this.userAccounttype == userType.individual;
    },
    userAccounttype() {
      let user = JSON.parse(localStorage.getItem("loggedInUser"));
      return user.accounttype;
    },
    disabled() {
      return this.$store.state.authentication.env == "staging" ? true : false;
    },
    userName() {
      let user = JSON.parse(localStorage.getItem("loggedInUser"));
      if (user !== null) {
        let firstname = user.firstname;
        let lastname = user.lastname;
        return firstname + " " + lastname;
      }
      return "";
    },
    userAccountType() {
      return this.$store.state.authentication.accountUserType;
    },
  },
  watch: {
    currentLocation(val, oldval) {
      if (val && val.length > 0) {
        this.setCurrentLocation();
      } else {
        this.currentLocation = oldval;
        this.setCurrentLocation();
      }
    },
  },
  methods: {
    moveToDashboard() {
      const onboardingType = JSON.parse(localStorage.getItem('loggedInUser'))
      switch (onboardingType.onboardingtype) {
        case 'ondemand':
          this.$router.push('/dashboard')
          break;

        case "3PL":
          this.$router.push('/3pl/dashboard')
          break;
      }
    },
    openSettings() {
      if (this.userAccountType === "private_customer") {
        this.$router.push({ name: "SettingsSelect" });
      } else if (this.userAccountType === "enterprise_partner") {
        this.showDashboardModal = true;
      } else if (this.userAccountType === "enterprise_customer") {
        this.$router.push({ name: "EnterpriseSettingsSelect" });
      } else if (this.userAccountType === "solo_operator") {
        this.showDashboardModal = true;
      }
    },
    setCurrentLocation() {
      this.$store.dispatch("setCurrentLocationId", this.currentLocation);
      this.$store.dispatch("setShoTerminal", true);
      localStorage.setItem("currentLocation", this.currentLocation);
    },
    async logout() {
      try {
        localStorage.clear();
        this.$_removeTwakTo('display: none !important');
        this.$router.push({ name: "Login" });
      } catch (error) {
        this.handleError(error);
      }
    },
    async getLocationsManaged() {
      try {
        this.loading = true;
        const response = await this.$_getLocationsManaged();
        this.$store.dispatch("saveManagedLocations", response.data.data);
        this.locations = response.data.data;

        let defaultLocation = response.data.data.find(
          (x) => x.location.isDefault == true
        );

        if (localStorage.getItem("currentLocation")) {
          this.currentLocation = localStorage.getItem("currentLocation");
          this.$store.dispatch("setCurrentLocationId", this.currentLocation);
        } else if (defaultLocation != undefined) {
          this.currentLocation = defaultLocation.locationId;
          this.$store.dispatch("setCurrentLocationId", defaultLocation.locationId);
          localStorage.setItem("currentLocation", defaultLocation.locationId);
        } else {
          if (response.data.data.length > 0) {
            this.currentLocation = response.data.data[0].locationId;
            this.setCurrentLocation();
          } else {
            this.currentLocation = undefined;
          }
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    toggleSideNav() {
      this.$store.dispatch("toggleSideNav");
    },
  },
};
</script>

<style lang="scss" scoped>
hr {
  border: 1px solid #e6e6e6;
  width: 100%;
}

.actions {
  position: absolute;
  background: #ffffff;
  top: 4.5rem;
  right: 20px;
  padding: 0.75rem;
  z-index: 999;
  font-size: 0.9rem;
  width: 10rem;

  background: #ffffff;

  /* Stroke */
  p {
    cursor: pointer;
  }

  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;
  display: flex;
  flex-direction: column;

  span {
    padding-right: 0.25rem;
  }

  >div {
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
    background: white;
  }
}

.top-navigation {
  background: #f9fafc;
  height: 4.5rem;
  max-width: 100%;
  width: 100%;
  display: flex;
  position: fixed;
  top: 0;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  justify-content: space-between;
  align-items: center;
  z-index: 999;
}

@media screen and (min-width: 768px) {
  .top-navigation {
    padding-right: 3rem;
    padding-left: 3rem;
  }
}

.notifications,
.user-information {
  background: #eff4fb;
  border-radius: 10px;
  display: flex;
  padding: 1rem;
  margin-right: 1rem;

  p {
    font-size: 0.9rem;
    font-weight: 500;
  }

  small {
    color: #1f1f1f;
    font-size: 0.75rem;
  }
}

.notification-count {
  background: #fcc210;
  border-radius: 10px;
  color: #ffffff;
  padding: 0.25rem 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logout {
  cursor: pointer;
  background: #10233e;
  border-radius: 10px;
  color: #ffffff;
  padding: 0.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    font-size: 0.6rem;
  }
}

.user-profile {
  border-left: 2px solid #dae8f6;
  padding-left: 1rem;
}
</style>
